module.exports = __webpack_public_path__ + "static/media/3.4bafd77d.jpeg";